import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { QualificationWithParent } from '../types'

type QualificationListResponse = QualificationWithParent[]

export const useQualificationsList = () => {
  return useQuery({
    queryKey: ['taxonomies', 'qualifications'],
    queryFn: () =>
      fetchApiWithToken<QualificationListResponse>({
        url: '/v1/taxonomies/qualifications?itemsPerPage=9000'
      })
  })
}
